/**
 * Standard resolution lookup by exact "WxH" string.
 * Used by UpscaleBadge (display), UpscaleOptionsModal (option building),
 * and formatDimensions (tier labels in detail panels / tooltips).
 */
export const STANDARD_RESOLUTIONS: Record<string, string> = {
  // SD
  '640x480': 'SD',
  '480x640': 'SD',
  '854x480': '480p',
  '480x854': '480p',
  '848x480': '480p',
  '480x848': '480p',
  // 720p
  '1280x720': '720p',
  '720x1280': '720p',
  // HD / 1080p
  '1920x1080': 'HD',
  '1080x1920': 'HD',
  // 2K
  '2048x1080': '2K',
  '1080x2048': '2K',
  '2560x1440': '1440p',
  '1440x2560': '1440p',
  // UHD / 4K
  '3840x2160': 'UHD',
  '2160x3840': 'UHD',
  '4096x2160': '4K',
  '2160x4096': '4K',
  // 8K
  '7680x4320': '8K',
  '4320x7680': '8K',
}
